export enum AiClassificationStatusEnum {
  None = 0,
  Classifying = 1,
  Done = 2,
  Error = 3,
  Queued = 4,
}
